export interface ResetFormActionType {
  type: '@formCreator/RESET';
}

export const resetForm = (): ResetFormActionType => ({
  type: '@formCreator/RESET',
});
